import Typography_module_default from "./Typography.module.js";
import classNames from "classnames";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Typography/Typography.tsx
var Typography = ({ as, children, type = "body", weight = "regular", size = "md", className, ...restProps }) => {
	return /* @__PURE__ */ jsx(as || "p", {
		...restProps,
		className: classNames(Typography_module_default.typography, Typography_module_default[`font-${type}-${size}-${weight}`], className),
		children
	});
};
//#endregion
export { Typography };

//# sourceMappingURL=Typography.js.map